'use client'

import Heading from '@/components/Heading/Heading'
import UserListView from './UserListView'
import { useCallback, useState } from 'react'
import RoleListView from '../roles/RoleListView'

const allTabs = [
  {
    name: 'User List',
  },
  {
    name: 'Roles',
    hidden: true,
  },
]

const tabs = allTabs.filter((tab) => !tab.hidden)

export default function Home() {
  const [selectedTab, setSelectedTab] = useState(0)

  const handleOnSelectedTabChange = (tabIndex: number) => {
    setSelectedTab(tabIndex)
  }

  const getCurrentTabContent = useCallback(() => {
    switch (selectedTab) {
      case 0:
        return <UserListView />
      case 1:
        return <RoleListView />
      default:
        return <UserListView />
    }
  }, [selectedTab])

  return (
    <div className="flex w-full bg-white gap-[32px]">
      <div className="flex-grow">
        <Heading
          title={'Users'}
          description={'Manage application users and roles.'}
          tab={{
            onSelectedChange: handleOnSelectedTabChange,
            selectedTab: selectedTab,
            tabs: tabs,
          }}
        ></Heading>
        <div className={'pr-xxl block'}>{getCurrentTabContent()}</div>
      </div>
    </div>
  )
}
